import { createDrawer } from '../../legacy/overlay.js';

/** @type {import('@vue/compat').ComponentOptions} */
export default {
    data: {
        index: 0,
        tabs: null
    },
    mounted() {
        if(!this.$refs.channelMenu)return
        this.index = this.$refs.channelMenu.getAttribute('data-index')
    },
    methods: {
        changeTab(index,type,orderby = false){
            if(this.index == index) return
            this.index = index
            window.qkMomentList?.changeTab(index,type,orderby)
        },
        createCircle(){
            createDrawer({componentName:'circleManage',componentProps: {
                type: 'create' // 传递给组件的props
            }})
        },
    }
};
